
require('angular').module("clientDashboardApp").factory("keywordService", ["$http", "$cacheFactory", function($http, $cacheFactory) {

  let getCache = (clearCache = false) => {
    const cacheName = 'keywordCache'
    const cache = $cacheFactory.get(cacheName);
    if (!cache) {
      return $cacheFactory(cacheName);
    } else {
      if (clearCache) {
        cache.removeAll();
      }
      return cache;
    }
  };

  return {
    listBingCategories: function(query, offset, limit, cache = true) {
      return $http.get("/locations/bingCategories", {params: {
          searchTerm: query || "", limit, offset
        }, cache: getCache(!cache)}).then(response => response.data)
    },
    listAppleCategories: function(query, offset, limit, cache = true) {
      return $http.get("/locations/appleCategories", {params: {
          searchTerm: query || "", limit, offset
        }, cache: getCache(!cache)}).then(response => response.data)
    },
    listHealthcareKeywords: function(query, offset, limit, cache = true) {
      return $http.get("/locations/healthcareKeywords", {params: {
          searchTerm: query || "", limit, offset
        }, cache: getCache(!cache)}).then(response => response.data)
    },
    listKeywords: function(query, offset, limit, listingMgmt, cache = true) {
      return $http.get("/locations/keywords", {params: {
        searchTerm: query || "", offset, limit,
        listingManagement: listingMgmt
      }, cache: getCache(!cache)}).then(response => response.data)
    },
    isValidForListingManagement: function(keyword, cache = true) {
      return $http.get("/locations/keywords/validForListingManagement", {params: {keyword}, cache: getCache(!cache)})
        .then(response => response.data)
    },
    saveKeyword: function(kw) {
      return $http.post("/locations/keywords", kw)
    },
    listVerticals: function(cache = true) {
      return $http.get("/locations/verticals", {cache: getCache(!cache)})
        .then(response => response.data)
    },
    saveVertical: function(vertical) {
      return $http.post("/locations/verticals", {...vertical})
        .then(response => response.data)
    },
    deleteVertical: (vertical) => $http
      .delete(`/locations/verticals/${vertical._id}`)
      .then(response => response.data)
  }
}]);
